"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Checkbox = void 0;
var utilities_1 = require("@fluentui/utilities");
var Checkbox_base_1 = require("./Checkbox.base");
var Checkbox_styles_1 = require("./Checkbox.styles");
exports.Checkbox = utilities_1.styled(Checkbox_base_1.CheckboxBase, Checkbox_styles_1.getStyles, undefined, { scope: 'Checkbox' });
//# sourceMappingURL=Checkbox.js.map